export const ReportViewOptionsTypes = {
  Summary: "summary",
  Sparkline: "sparkline"
};
